import { apiGet } from './client'

export interface AggregatedPositionByAccount {
  alias: string
  qty: number
  market_value: number
}

export interface AggregatedPosition {
  symbol: string
  asset_class: string
  total_qty: number
  net_qty: number
  market_value: number
  unrealized_pnl: number
  by_account: AggregatedPositionByAccount[]
}

export interface AggregatedPositionsResponse {
  as_of: string
  asset_class_filter: string | null
  total_positions: number
  unique_symbols: number
  by_symbol: AggregatedPosition[]
}

export interface AggregatedAccountRow {
  alias: string
  /** When true, omitted from portfolio totals (still listed for single-account views). */
  exclude_from_metrics?: boolean
  net_liquidation: number
  buying_power: number
  margin_used: number
  cash: number
  total_exposure?: number
  total_unrealized_pnl?: number
  positions_count?: number
  share_of_total_nlv_pct?: number | null
  // Extended IB-summary fields (sidebar parity with trade01)
  positions_value?: number | null
  ib_positions_value?: number | null
  available_funds?: number | null
  excess_liquidity?: number | null
  equity_with_loan_value?: number | null
  init_margin?: number | null
  maintenance_margin?: number | null
  full_init_margin_req?: number | null
  full_maint_margin_req?: number | null
  sma?: number | null
  day_trades_remaining?: number | null
  reg_t_margin?: number | null
  reg_t_equity?: number | null
  cushion?: number | null
  look_ahead_next_change?: number | null
  segment_title?: string | null
  // Server-derived
  juice_profit_remaining?: number | null
  projected_balance?: number | null
}

export interface AggregatedRiskTotals {
  net_liquidation: number
  buying_power: number
  margin_used: number
  cash: number
  total_exposure: number
  total_unrealized_pnl: number
  // Summable IB fields
  positions_value?: number
  available_funds?: number
  excess_liquidity?: number
  equity_with_loan_value?: number
  init_margin?: number
  maintenance_margin?: number
  full_init_margin_req?: number
  full_maint_margin_req?: number
  sma?: number
  reg_t_margin?: number
  reg_t_equity?: number
  // Server-derived
  juice_profit_remaining?: number
  projected_balance?: number
}

export interface AggregatedRiskResponse {
  as_of: string
  totals: AggregatedRiskTotals
  by_account: AggregatedAccountRow[]
}

export const getAggregatedPositions = (assetClass?: string) =>
  apiGet<AggregatedPositionsResponse>('/aggregated/positions', { params: { asset_class: assetClass } })

export const getAggregatedRisk = () => apiGet<AggregatedRiskResponse>('/aggregated/risk')
